import React from 'react';

const CommonCompatibilityRemoveWarning = (props) => {
  const {featureGroup, featureGroupName, } = props;
  void featureGroup;

  return (
    <div className="compatibility-warning">
      <p>
        <strong>'{featureGroupName}' isn't compatible with you current change.</strong>
      </p>
      <p>
        This update will remove '{featureGroupName}' from your project.
      </p>
    </div>
  );
};

export default CommonCompatibilityRemoveWarning;
